import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import RefererReportContainer from 'app/containers/Marketing/RefererReport'

const RefererReportPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_introduce_program)}</PageTitle>
      <RefererReportContainer />
    </>
  )
}
const RefererReportPage = memo(RefererReportPageCpn, isEqual)

export default RefererReportPage
